import React, { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import {
  Home, Users, MessageSquare, Video, Settings, 
  ChevronDown, ChevronRight, Trophy, FileSignature, Inbox,
  Mail, Send, Sparkles, FolderKanban, Image as ImageIcon,
  Hash, Calendar, DollarSign, Calculator, Scale, Globe,
  Megaphone, Briefcase, LogOut, X as XIcon, Gauge, ListTodo,
  BarChart3, Search, MapPin, Building2, ShoppingBag, LayoutDashboard, ShieldCheck, Palette, FileText, TrendingUp, Activity
} from "lucide-react";
import { useAuth } from "../context/AuthContext";

const AVATAR = "/gp-app-icon.png";

// New organized navigation structure
const NAVIGATION = [
  {
    id: "command",
    title: "COMMAND CENTER",
    icon: Home,
    defaultOpen: true,
    items: [
      { to: "/crm/command-center", icon: Gauge, label: "Dashboard", end: true },
      { to: "/crm/project-health", icon: Activity, label: "Project Health" },
      { to: "/crm/analytics", icon: BarChart3, label: "Analytics" },
      { to: "/crm/calendar", icon: Calendar, label: "Calendar" },
    ],
  },
  {
    id: "ai",
    title: "AI STUDIO",
    icon: Sparkles,
    items: [
      { to: "/crm/ai", tab: "today", defaultTab: true, icon: Sparkles, label: "Today", testId: "sidebar-ai-today" },
      { to: "/crm/ai", tab: "copilot", icon: MessageSquare, label: "Copilot" },
      { to: "/crm/ai", tab: "campaigns", icon: Megaphone, label: "Campaigns" },
      { to: "/crm/ai", tab: "usage", icon: BarChart3, label: "AI Usage" },
      { to: "/crm/grok-ai", icon: Sparkles, label: "Grok AI" },
    ],
  },
  {
    id: "money",
    title: "MONEY",
    icon: DollarSign,
    items: [
      { to: "/crm/money", tab: "payouts", defaultTab: true, icon: DollarSign, label: "Payouts", testId: "sidebar-money-payouts" },
      { to: "/crm/money", tab: "expenses", icon: Calculator, label: "Expenses & P&L" },
      { to: "/crm/money", tab: "imports", icon: Calculator, label: "Imports" },
      { to: "/crm/money", tab: "observations", icon: BarChart3, label: "Platform Observations" },
      { to: "/crm/money", tab: "leaderboard", icon: Trophy, label: "Leaderboard" },
    ],
  },
  {
    id: "email",
    title: "EMAIL",
    icon: Mail,
    items: [
      { to: "/crm/email", tab: "compose", defaultTab: true, icon: Send, label: "Compose", testId: "sidebar-email-compose" },
      { to: "/crm/email", tab: "inbox", icon: Inbox, label: "Email Inbox" },
      { to: "/crm/email", tab: "sent", icon: Mail, label: "Sent Log" },
      { to: "/crm/email", tab: "privacy", icon: ShieldCheck, label: "Privacy & Legal Email" },
    ],
  },
  {
    id: "social",
    title: "SOCIAL",
    icon: Hash,
    items: [
      { to: "/crm/social", tab: "overview", defaultTab: true, icon: Gauge, label: "Social Overview", testId: "sidebar-social-overview" },
      { to: "/crm/social", tab: "queue", icon: Calendar, label: "X Queue" },
      { to: "/crm/x", icon: XIcon, label: "X Studio" },
      { to: "/crm/social", tab: "tracker", icon: FolderKanban, label: "Multi-Tracker" },
    ],
  },
  {
    id: "members",
    title: "MEMBERS & STORE",
    icon: Users,
    items: [
      { to: "/crm/fans", icon: Users, label: "Fans" },
      { to: "/crm/members", icon: Users, label: "Members Management" },
      { to: "/crm/member-areas", icon: Video, label: "Member Areas" },
      { to: "/crm/store-management", icon: ShoppingBag, label: "Store Management" },
      { to: "/crm/subscriptions", icon: DollarSign, label: "Subscriptions" },
    ],
  },
  {
    id: "crew",
    title: "CREW & STAFF",
    icon: Users,
    items: [
      { to: "/crm/crew", icon: Users, label: "Team Directory" },
      { to: "/studios", icon: Building2, label: "Studios" },
    ],
  },
  {
    id: "messaging",
    title: "MESSAGING",
    icon: MessageSquare,
    defaultOpen: true,
    items: [
      { to: "/crm/inbox", icon: Inbox, label: "Inbox" },
    ],
  },
  {
    id: "submissions-deals",
    title: "SUBMISSIONS & DEALS",
    icon: Briefcase,
    defaultOpen: true,
    items: [
      { to: "/crm/submissions", icon: FileSignature, label: "Submissions" },
      { to: "/crm/deals", icon: Briefcase, label: "Deals" },
      { to: "/crm/brands", icon: Building2, label: "Brands" },
      { to: "/crm/events-shows", icon: Calendar, label: "Events & Shows" },
    ],
  },
  {
    id: "content",
    title: "CONTENT",
    icon: Video,
    items: [
      { to: "/crm/catalog", icon: Video, label: "Content Library" },
      { to: "/crm/posts-updates", icon: FileText, label: "Posts & Updates" },
      { to: "/pictures", icon: ImageIcon, label: "Media Gallery" },
      { to: "/crm/landing", icon: Globe, label: "Landing Editor" },
      { to: "/crm/companion-bookings", icon: Calendar, label: "Escort Companion" },
      { to: "/crm/ads-management", icon: Megaphone, label: "Ads & Affiliate" },
      { to: "/crm/studio-scenes", icon: Video, label: "Studio Scenes" },
      { to: "/crm/pricing-strategy", icon: TrendingUp, label: "Pricing Strategy" },
    ],
  },
  {
    id: "research",
    title: "RESEARCH",
    icon: Search,
    items: [
      { to: "/crm/search-hub", icon: Search, label: "Search Hub" },
    ],
  },
  {
    id: "hubs",
    title: "PLATFORM HUBS",
    icon: Globe,
    items: [
      { to: "/crm/platform-hub", icon: LayoutDashboard, label: "Platform Matrix" },
      { to: "/crm/onlyfans-vip", icon: Users, label: "OnlyFans VIP" },
      { to: "/crm/onlyfans-free", icon: Users, label: "OnlyFans Free" },
      { to: "/crm/jff", icon: Users, label: "JustFor.Fans" },
      { to: "/platform-hubs/faphouse", icon: Globe, label: "FapHouse" },
      { to: "/crm/rfc", icon: Globe, label: "RawFuckClub" },
      { to: "/crm/theblowers", icon: Globe, label: "TheBlowers" },
      { to: "/crm/social", tab: "instagram", icon: ImageIcon, label: "Instagram" },
      { to: "/crm/tiktok", icon: Video, label: "TikTok" },
      { to: "/crm/intimaly-hub", icon: Globe, label: "Intimaly" },
    ],
  },
  {
    id: "legal",
    title: "LEGAL",
    icon: Scale,
    items: [
      { to: "/crm/compliance", icon: Scale, label: "Compliance" },
      { to: "/crm/content-protection", icon: ShieldCheck, label: "Content Protection" },
      { to: "/crm/legal-docs-editor", icon: FileText, label: "Legal Docs Editor" },
    ],
  },
  {
    id: "system",
    title: "SETTINGS",
    icon: Settings,
    items: [
      { to: "/crm/settings", tab: "connections", defaultTab: true, icon: Settings, label: "Connections", testId: "sidebar-settings-connections" },
      { to: "/crm/settings", tab: "ai", icon: Sparkles, label: "AI" },
      { to: "/crm/settings", tab: "mux", icon: Video, label: "Mux Video" },
      { to: "/crm/settings", tab: "brand", icon: Palette, label: "Brand & Theme", testId: "sidebar-design-settings" },
      { to: "/crm/settings", tab: "roles", icon: Users, label: "Roles & Permissions" },
      { to: "/crm/settings", tab: "activity", icon: ListTodo, label: "Activity Log", enhanced: true },
      { to: "/crm/settings", tab: "admin", icon: ShieldCheck, label: "Admin Tools" },
    ],
  },
];

const STORAGE_KEY = "crm_sidebar_sections";

// Link target for a nav item; section tabs live in ?tab=.
function itemHref(item) {
  return item.tab ? `${item.to}?tab=${item.tab}` : item.to;
}

function itemKey(item) {
  return itemHref(item);
}

// Mirrors NavLink matching: exact when `end`, otherwise path or nested path.
// Section-tab items also match on ?tab= (a missing tab means the default tab).
function isItemActive(item, pathname, search = "") {
  const path = (pathname.replace(/\/+$/, "") || "/").toLowerCase();
  const to = item.to.toLowerCase();
  if (item.tab) {
    if (path !== to) return false;
    const current = new URLSearchParams(search || "").get("tab");
    return current ? current === item.tab : Boolean(item.defaultTab);
  }
  return item.end ? path === to : path === to || path.startsWith(`${to}/`);
}

function findActiveSectionId(pathname, search) {
  const section = NAVIGATION.find((s) => s.items.some((item) => isItemActive(item, pathname, search)));
  return section ? section.id : null;
}

function loadExpanded() {
  const defaults = Object.fromEntries(
    NAVIGATION.filter((section) => section.defaultOpen).map((section) => [section.id, true])
  );
  try {
    const stored = JSON.parse(localStorage.getItem(STORAGE_KEY));
    if (stored && typeof stored === "object") return { ...defaults, ...stored };
  } catch {
    // Unreadable storage falls back to the default.
  }
  return defaults;
}

export default function Sidebar({ mobileOpen = false, onMobileClose }) {
  const { logout } = useAuth();
  const { pathname, search = "" } = useLocation();
  const [expandedSections, setExpandedSections] = useState(() => {
    const activeId = findActiveSectionId(pathname, search);
    const stored = loadExpanded();
    return activeId ? { ...stored, [activeId]: true } : stored;
  });

  useEffect(() => {
    const activeId = findActiveSectionId(pathname, search);
    if (activeId) setExpandedSections((prev) => (prev[activeId] ? prev : { ...prev, [activeId]: true }));
  }, [pathname, search]);

  useEffect(() => {
    try {
      localStorage.setItem(STORAGE_KEY, JSON.stringify(expandedSections));
    } catch {
      // Persistence is best-effort.
    }
  }, [expandedSections]);

  const toggleSection = (sectionId) => {
    setExpandedSections(prev => ({
      ...prev,
      [sectionId]: !prev[sectionId]
    }));
  };

  return (
    <>
      {/* Mobile backdrop */}
      {mobileOpen && (
        <div
          className="lg:hidden fixed inset-0 bg-black/60 backdrop-blur-sm z-30 fade-up"
          onClick={onMobileClose}
          data-testid="sidebar-backdrop"
        />
      )}
      
      <aside
        className={`flex flex-col w-[280px] z-40 transition-transform duration-300 ease-out
          ${mobileOpen ? "translate-x-0 fixed inset-y-0 left-0" : "-translate-x-full fixed inset-y-0 left-0"}
          lg:translate-x-0 lg:sticky lg:top-0 lg:flex lg:min-h-screen`}
        data-testid="sidebar"
        style={{
          background: 'linear-gradient(180deg, #0a0a0a 0%, #000000 100%)',
          borderRight: '1px solid rgba(168, 85, 247, 0.1)',
          height: '100vh',
          overflowY: 'auto',
        }}
      >
        {/* Header */}
        <div className="p-5 flex items-center justify-between border-b border-white/5">
          <div className="flex items-center gap-3">
            <div className="w-12 h-12 overflow-hidden relative rounded-2xl bg-gradient-to-br from-purple-500 to-pink-500 p-0.5">
              <div className="w-full h-full rounded-2xl overflow-hidden bg-black">
                <img src={AVATAR} alt="GP App" className="w-full h-full object-cover" />
              </div>
            </div>
            <div>
              <div className="font-bold text-lg text-white leading-tight">
                GioPilos
              </div>
              <div className="text-xs text-gray-500 mt-0.5">
                Command Center
              </div>
            </div>
          </div>
          
          {/* Close button - mobile only */}
          <button
            onClick={onMobileClose}
            className="lg:hidden p-2 rounded-xl hover:bg-white/5 transition text-gray-400 hover:text-white"
            data-testid="sidebar-close"
          >
            <XIcon size={18} />
          </button>
        </div>

        {/* Navigation */}
        <nav className="flex-1 py-4 px-3 space-y-2">
          {NAVIGATION.map((section) => {
            const isExpanded = expandedSections[section.id];
            const SectionIcon = section.icon;
            
            return (
              <div key={section.id} className="space-y-1">
                {/* Section Header */}
                <button
                  onClick={() => toggleSection(section.id)}
                  className={`w-full flex items-center justify-between px-3 py-2.5 rounded-xl text-sm font-semibold transition-all duration-200 group ${
                    isExpanded 
                      ? 'text-white bg-white/10' 
                      : 'text-gray-400 hover:text-white hover:bg-white/5'
                  }`}
                >
                  <div className="flex items-center space-x-2.5">
                    <SectionIcon size={18} className={`transition ${
                      isExpanded ? 'text-purple-300' : 'text-purple-400 group-hover:text-purple-300'
                    }`} />
                    <span className="uppercase tracking-wider text-xs">{section.title}</span>
                  </div>
                  <ChevronDown 
                    size={16} 
                    className={`transition-transform duration-200 ${
                      isExpanded ? 'rotate-0 text-gray-400' : '-rotate-90 text-gray-600'
                    }`} 
                  />
                </button>

                {/* Section Items */}
                {isExpanded && (
                  <div className="space-y-0.5 pl-2">
                    {section.items.map((item) => {
                      const ItemIcon = item.icon;
                      const isActive = isItemActive(item, pathname, search);
                      return (
                        <Link
                          key={itemKey(item)}
                          to={itemHref(item)}
                          data-testid={item.testId}
                          aria-current={isActive ? "page" : undefined}
                          className={
                            `flex items-center space-x-3 px-3 py-2.5 rounded-xl text-sm transition-all duration-200 group ${
                              isActive
                                ? 'bg-gradient-to-r from-pink-500/25 to-fuchsia-500/20 text-white border border-[#FF10F0]/50 shadow-lg shadow-[#FF10F0]/20'
                                : item.enhanced
                                ? 'text-purple-300 hover:text-white hover:bg-gradient-to-r hover:from-purple-500/10 hover:to-pink-500/10 hover:border hover:border-purple-500/20'
                                : 'text-gray-400 hover:text-white hover:bg-white/5'
                            }`
                          }
                        >
                          <ItemIcon size={18} className={`flex-shrink-0 group-hover:scale-110 transition-transform ${item.enhanced ? 'text-purple-400' : ''}`} />
                          <span className="font-medium">{item.label}</span>
                          {item.enhanced && (
                            <span className="ml-auto px-2 py-0.5 bg-purple-500/20 text-purple-300 text-[10px] font-bold rounded uppercase">
                              Enhanced
                            </span>
                          )}
                        </Link>
                      );
                    })}
                  </div>
                )}
              </div>
            );
          })}
        </nav>

        {/* Footer */}
        <div className="p-4 border-t border-white/5 space-y-3">
          {/* System Status - Connected to actual data */}
          <div className="bg-gradient-to-br from-purple-900/20 to-pink-900/20 backdrop-blur-xl border border-purple-500/20 rounded-2xl p-4">
            <div className="text-xs text-gray-400 mb-2">System Status</div>
            <div className="flex items-center justify-between">
              <div>
                <div className="text-lg font-bold text-green-400">All Systems Operational</div>
                <div className="text-xs text-gray-500">Last checked: {new Date().toLocaleTimeString()}</div>
              </div>
              <div className="w-12 h-12 rounded-xl bg-green-500/20 flex items-center justify-center">
                <div className="w-3 h-3 rounded-full bg-green-400 animate-pulse"></div>
              </div>
            </div>
          </div>

          {/* Logout Button */}
          <button
            onClick={logout}
            className="w-full flex items-center justify-center space-x-2 px-4 py-3 bg-red-500/10 hover:bg-red-500/20 text-red-400 rounded-2xl transition-all duration-200 font-medium border border-red-500/20"
          >
            <LogOut size={18} />
            <span>Logout</span>
          </button>
        </div>
      </aside>
    </>
  );
}
